import { throwApiError } from '@/shared/utils/apiResponse';
import { apiPost } from '@/shared/utils/requestBuilder';
import { ImproveTemplateInput, ImproveTemplateResponse } from '../types';

const BASE_URL = '/ia';

export const iaService = {
  async improveTemplate(data: ImproveTemplateInput): Promise<ImproveTemplateResponse> {
    const response = await apiPost(`${BASE_URL}/template/improve`, data);
    if (!response.ok) {
      await throwApiError(response, 'Erro ao melhorar template com IA');
    }
    return response.json();
  },
};
